export default {
  data() {
    return {
        inputHourValue: 0
    }
  },
  /* 
     在template里的绑定不生效
  */
  changeHours(val) {
    // 超过12 或者小于0，提示 一天工时不允许超过12小时
    if (this.inputHourValue > 12 || this.inputHourValue < 0) {
      this.$message({
        type: "warning",
        message: "一天工时不允许超过12小时和小于1小时"
      });
    }
  },
  inputHours(val) {
    this.inputHourValue = val.target.value;
  }
};
